import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CustomAlert from "../../shared/CustemAlert";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

export default function Add({ increment, counter }) {
  const [title, setTitle] = useState(""); // useState hook
  const [error, setError] = useState(false);
  const [isAdded, SetIsAdded] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [newMayor, setNewMayor] = useState({
    full_name: "",
    full_name_arb: "",
    start_date: null,
    end_date: null,
    active: false,
  });

  // handle change event
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    if (name === "active") {
      setNewMayor((prevState) => ({
        ...prevState,
        active: e.target.checked,
      }));
    } else
      setNewMayor((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/mayor/",
          newMayor,
          {
            signal: controller.signal,
          }
        );
        SetIsAdded(true);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    postData();
    setTitle("");
    setError(false);
  };
  // render

  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3 border  ">
          <div className="card-header">
            <h2>ראשי רשויות</h2>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="full_name">שם ראש הרשות</label>
                    <input
                      type="text"
                      name="full_name"
                      value={newMayor.full_name}
                      onChange={handleChange}
                      className="form-control"
                      id="full_name"
                      placeholder="תקליד שם מלא"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="full_name_arb">שם ראש הרשות (ערבית)</label>
                    <input
                      type="text"
                      name="full_name_arb"
                      value={newMayor.full_name_arb}
                      onChange={handleChange}
                      className="form-control"
                      id="full_name_arb"
                      placeholder="תקליד שם מלא בערבית"
                    />
                  </div>

                  <Col>
                    <div className="form-group">
                      <label htmlFor="start_date">תקופה מ-</label>
                      <input
                        type="date"
                        name="start_date"
                        className="form-control"
                        id="start_date"
                        value={newMayor.start_date}
                        placeholder=""
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="end_date">תקופה עד-</label>
                      <input
                        type="date"
                        name="end_date"
                        className="form-control"
                        id="end_date"
                        value={newMayor.end_date}
                        placeholder=""
                        onChange={handleChange}
                      />
                    </div>
                  </Col>

                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף ראש רשות חדש
                  </button>
                </form>
              </Col>
            </Row>

            {isAdded && (
              <CustomAlert
                setShow={SetIsAdded}
                alertHeader={title}
                alertBody="ראש הרשות נוסף בהצלחה"
              />
            )}
          </div>
        </div>
      </center>
    </div>
  );
}
